import client from "../../graphql/client";
import { loader } from "graphql.macro";

const fetchCompanyLabelsQuery = loader("../../graphql/queries/adminCompanyLabels.graphql");

export default function fetchOrganisationLabelsAction() {
    return () => {
        return client.query({
            query: fetchCompanyLabelsQuery,
            fetchPolicy: "network-only"
        });
    };
}
